import React, { useEffect, useState } from 'react';
import MyCascader from "../vehicle-cascader";
import { Form } from 'antd';
interface PropsType {
	enums?: any;
	isRequired?: any;
	storeCode?: string;
	onChange?: any
	defaultValue?: any
}

const MyModelCascader: React.FC<PropsType> = props => {
  const [selectedValues, setSelectedValues] = useState<any>(undefined);
	const { onChange, defaultValue,storeCode } = props
	const cascaderChange = (value: any) => {
    setSelectedValues(value || undefined)
		onChange(value?.[2] || '')
	}

	return <MyCascader value={selectedValues} defaultValue={defaultValue} onChange={cascaderChange} storeCode={storeCode}></MyCascader>
};

export default MyModelCascader;
